<template>
  <div class="flex items-center ml-1">
    <img :src="captcha" class="border rounded">
    <button
      type="button"
      @click="getCaptcha"
      class="ml-1 px-3 py-2 border border-transparent text-sm rounded-md text-white bg-gray-600 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700 transition ease-in-out duration-150"
    >
      <svg class="-ml-0.5 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10,3 C6.13400675,3 3,6.13400675 3,10 C3,11.9329966 3.78350169,13.6829966 5.05025253,14.9497475 L6.46446609,13.5355339 C5.55964406,12.6307119 5,11.3807119 5,10 C5,7.23857625 7.23857625,5 10,5 L10,3 L10,3 Z M14.9497475,5.05025253 C16.2164983,6.31700338 17,8.06700338 17,10 C17,13.8659932 13.8659932,17 10,17 L10,15 C12.7614237,15 15,12.7614237 15,10 C15,8.61928813 14.4403559,7.36928813 13.5355339,6.46446609 L14.9497475,5.05025253 L14.9497475,5.05025253 Z M10,20 L6,16 L10,12 L10,20 L10,20 Z M10,8 L14,4 L10,0 L10,8 L10,8 Z" clip-rule="evenodd"></path>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      captcha: '/img/null.png'
    }
  },

  methods: {
    async getCaptcha() {
      const response = await axios.post('/captcha')
      this.captcha = response.data.captcha
    },

    clearCaptcha() {
      this.captcha = '/img/null.png'
    }
  }
}
</script>
